import type {
    PlanId,
    SubscriptionPlan,
    OrganizationSubscription
} from '../../../domain/entities/Subscription';

// =============================================================================
// TIPOS LOCAIS (Representação do Banco)
// =============================================================================

import type { Database } from '../../../src/types/database.types';

// =============================================================================
// TIPOS LOCAIS (Representação do Banco)
// =============================================================================

export type SubscriptionPlanRow = Database['public']['Tables']['subscription_plans']['Row'];
export type OrganizationSubscriptionRow = Database['public']['Tables']['organizations']['Row'];

// Interface auxiliar para tipar o JSONB de features
interface PlanFeaturesJSON {
    meta_tracking?: boolean;
    auto_movement?: boolean;
    instagram_dm?: unknown;
    instagram_tracking?: unknown;
    google_ads?: unknown;
    display_items?: unknown;
}

// =============================================================================
// MAPPERS
// =============================================================================

export function mapPlanRowToEntity(row: SubscriptionPlanRow): SubscriptionPlan {
    const features = (row.features as unknown as PlanFeaturesJSON) || {};

    return {
        id: row.id as PlanId,
        name: row.name,
        pricePerUser: row.price_per_user,
        minUsers: row.min_users,
        maxFunnels: row.max_funnels,
        maxContacts: row.max_contacts,
        maxWhatsapp: row.max_whatsapp,
        maxAdAccounts: row.max_ad_accounts,
        features: {
            metaTracking: features.meta_tracking === true,
            autoMovement: features.auto_movement === true,
            instagramDm: mapFeatureStatus(features.instagram_dm),
            instagramTracking: mapFeatureStatus(features.instagram_tracking),
            googleAds: mapFeatureStatus(features.google_ads),
            displayItems: Array.isArray(features.display_items) ? features.display_items as string[] : undefined,
        },
        stripePriceId: row.stripe_price_id,
        isActive: row.is_active ?? false,
    };
}

export function mapSubscriptionRowToEntity(row: OrganizationSubscriptionRow): OrganizationSubscription {
    return {
        planId: (row.plan || 'basic') as PlanId,
        status: row.subscription_status as OrganizationSubscription['status'],
        stripeCustomerId: row.stripe_customer_id,
        stripeSubscriptionId: row.stripe_subscription_id,
        quantity: row.quantity ?? 1,
        trialEndsAt: row.trial_ends_at ? new Date(row.trial_ends_at) : null,
        blockedAt: row.blocked_at ? new Date(row.blocked_at) : null,
    };
}

export function mapFeatureStatus(value: unknown): 'available' | 'coming_soon' | 'unavailable' {
    if (value === true || value === 'available') return 'available';
    if (value === 'coming_soon') return 'coming_soon';
    return 'unavailable';
}
